<template>
  <div v-title="$route.meta.title">
    <el-row class="main-title">
      <p class="title-name">{{$route.meta.title}} - {{orderInfo.title}}</p>
    </el-row>


    <layout-panel>
      <template slot="header">问卷概况</template>

      <el-row class="status-bar flex-center"
              :gutter="20">
        <span class="status-item green-style"><i class="el-icon-circle-check-outline"></i> 已发布</span>
        <span><i class="el-icon-arrow-right"></i></span>
        <span class="status-item green-style"><i class="el-icon-circle-check-outline"></i> 进行中</span>
        <span><i class="el-icon-arrow-right"></i></span>
        <span class="status-item"
              :class="orderInfo.statusColor"><i :class="orderInfo.statusIcon"></i> {{orderInfo.statusBarText}}</span>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <span>问卷ID：</span><span>{{orderInfo.orderid}}</span>
        </el-col>
        <el-col :span="12">
          <span>问卷状态：</span><span>{{orderInfo.statusText}}</span>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <span>上线时间：</span><span>{{orderInfo.starttime || orderPlaceholder}}</span>
        </el-col>
        <el-col :span="12">
          <span>下线时间：</span><span>{{orderInfo.deadline || orderPlaceholder}}</span>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <span>价格：</span><span>{{orderInfo.salary || orderPlaceholder}} 元</span>
        </el-col>
      </el-row>
    </layout-panel>


    <layout-panel>
      <template slot="header">问卷作答信息</template>

      <el-row :gutter="20">
        <el-col :span="12">
          <span>提交时间：</span><span>{{orderInfo.userfinishtime || orderPlaceholder}}</span>
        </el-col>
        <el-col :span="12">
          <span>作答时长：</span><span> {{(Date.parse(orderInfo.userfinishtime) - Date.parse(orderInfo.userstarttime))/1000|formatTimer}}</span>
        </el-col>
      </el-row>
    </layout-panel>


    <layout-panel v-if="isShowAdminCheckInfo">
      <template slot="header">问卷审核信息</template>

      <el-row :gutter="20">
        <el-col :span="12">
          <span>审核时间：</span><span>{{orderInfo.reviewedtime || orderPlaceholder}}</span>
        </el-col>
        <el-col :span="12">
          <span>审核结果：</span><span>{{orderInfo.statusText || orderPlaceholder}}</span>
        </el-col>
      </el-row>

      <el-row :gutter="20"
              v-if="orderInfo.errormessage">
        <el-col :span="24">
          <span>审核不通过原因：</span><span>{{orderInfo.errormessage || orderPlaceholder}}</span>
        </el-col>
      </el-row>

      <el-row :gutter="20"
              v-if="orderInfo.review_message">
        <el-col :span="24">
          <span>复审通过原因：</span><span>{{orderInfo.review_message || orderPlaceholder}}</span>
        </el-col>
      </el-row>
    </layout-panel>

    <question-review v-if="Object.keys(orderInfo).length"/>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import QuestionReview from '@views/teke-order-review/pages/TekeOrderReview.vue'

export default {
  components: {QuestionReview},
  data () {
    return {
      orderPlaceholder: '-',
      orderInfo: {},
      statusConf: {
        '2': '进行中',
        '3': '进行中',
        '4': '待审核',
        '5': '审核通过',
        '-2': '审核不通过',
        '40': '管理员复审',
        '-1': '已放弃',
      },
    }
  },

  computed: {
    ...mapState({}),

    // 是否显示管理员复审信息栏
    isShowAdminCheckInfo () {
      return this.orderInfo.reviewtime > 1 || false
    },
  },

  beforeRouteUpdate (to, from, next) {
    this.getQstInfo(to.params.id)
    next()
  },

  mounted () {
    this.getQstInfo(this.$route.params.id)
  },

  methods: {
    ...mapActions([]),

    // 获取问卷详情
    getQstInfo (orderId) {
      if (!orderId) return

      request.page('getOrderDetail', {id: orderId}).then((res) => { // 获取成功
        const resData = res.data
        this.$store.commit('orderReview/SET_ORDER_DETAIL_DATA', resData)

        resData.statusText = this.statusConf[resData.status]

        if (resData.userfinishtime && resData.userstarttime) {
          resData.userTimeLong = (filter.toUnix(resData.userfinishtime) - filter.toUnix(resData.userstarttime)) / 60
        }

        switch (resData.status) {
          default:
            resData.statusBarText = this.statusConf[resData.status]
            break
          case '2':
          case '3':
            resData.statusBarText = '待审核'
            break
          case '-1':
            resData.statusBarText = '已关闭'
            break
        }

        switch (resData.status) {
          default:
            resData.statusColor = 'green-style'
            break
          case '2':
          case '3':
            resData.statusColor = 'grey-style'
            break
          case '-2':
            resData.statusColor = 'red-style'
            break
          case '-1':
            resData.statusColor = 'blue-style'
            break
        }

        switch (resData.status) {
          default:
            resData.statusIcon = 'sj-icon-quan'
            break
          case '5':
            resData.statusIcon = 'el-icon-circle-check-outline'
            break
          case '-1':
          case '-2':
            resData.statusIcon = 'el-icon-circle-close-outline'
            break
        }

        this.orderInfo = resData
      })
    },
  },
}
</script>


<style lang="scss"
       scoped>
.flex-center {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.status-bar {
  justify-content: space-between;
  margin: 0 0 30px;
  font-size: 16px;

  > span {
    margin: 10px;
    color: #C0C4CC;

    &.status-item {
      &.green-style {
        color: #4FC2B9;
      }

      &.red-style {
        color: #FF1600;
      }

      &.blue-style {
        color: #409EFF;
      }

      &.grey-style {
        color: #666;
      }
    }
  }
}

.el-col {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/teke-order/pages/TekeOrderDetail.vue